import { render, staticRenderFns } from "./memberBan.vue?vue&type=template&id=20ce3f3a&"
import script from "./memberBan.vue?vue&type=script&lang=js&"
export * from "./memberBan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports